module.exports = __webpack_public_path__ + "img/gift4-01-c04-t1.e9e66c0d.png";